
import apiClient from '../helpers/api_client';

// Roles
export const getAllRoles = (page = 0, size = 10) =>
  apiClient.get('/roles', { params: { page, size, sort: 'createdAt,desc' } });
export const getRole = (id) => apiClient.get(`/roles/${id}`);
export const createRole = (data) => apiClient.post('/roles', data);
export const updateRole = (id, data) => apiClient.put(`/roles/${id}`, data);
export const deleteRole = (id) => apiClient.delete(`/roles/${id}`);

// Clients
export const getAllClients = (page = 0, size = 10) =>
  apiClient.get('/clients', { params: { page, size, sort: 'createdAt,desc' } });
export const getClient = (id) => apiClient.get(`/clients/${id}`);
export const createClient = (data) => apiClient.post('/clients', data);
export const updateClient = (id, data) => apiClient.put(`/clients/${id}`, data);
export const deleteClient = (id) => apiClient.delete(`/clients/${id}`);

// Companies
export const getAllCompanies = (page = 0, size = 10) =>
  apiClient.get('/companies', { params: { page, size, sort: 'createdAt,desc' } });
export const getCompany = (id) => apiClient.get(`/companies/${id}`);
export const createCompany = (data) => apiClient.post('/companies', data);
export const updateCompany = (id, data) => apiClient.put(`/companies/${id}`, data);
export const deleteCompany = (id) => apiClient.delete(`/companies/${id}`);

// Regions
export const getAllRegions = (page = 0, size = 10) =>
  apiClient.get('/regions', { params: { page, size, sort: 'createdAt,desc' } });
export const getRegion = (id) => apiClient.get(`/regions/${id}`);
export const createRegion = (data) => apiClient.post('/regions', data);
export const uploadRegions = (formData) =>
  apiClient.post('/regions/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateRegion = (id, data) => apiClient.put(`/regions/${id}`, data);
export const deleteRegion = (id) => apiClient.delete(`/regions/${id}`);

// Districts
export const getAllDistricts = (page = 0, size = 10) =>
  apiClient.get('/districts', { params: { page, size, sort: 'createdAt,desc' } });
export const getDistrict = (id) => apiClient.get(`/districts/${id}`);
export const createDistrict = (data) => apiClient.post('/districts', data);
export const uploadDistricts = (formData) =>
  apiClient.post('/districts/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateDistrict = (id, data) => apiClient.put(`/districts/${id}`, data);
export const deleteDistrict = (id) => apiClient.delete(`/districts/${id}`);

// =====================
// Users
// =====================

export const getAllUsers = (page = 0, size = 10) =>
  apiClient.get('/users', { params: { page, size, sort: 'createdAt,desc' } });

export const getUser = (id) => apiClient.get(`/users/${id}`);

export const createUser = (data) => apiClient.post('/users/register', data);

export const updateUser = (id, data) => apiClient.put(`/users/${id}`, data);

export const deleteUser = (id) => apiClient.delete(`/users/${id}`);

export const resetUser = (id, data = {}) =>
  apiClient.put(`/users/reset/${id}`, data);

export const blockActivateUser = (id) =>
  apiClient.put(`/users/block-activate/${id}`);

export const changeUserPassword = (id, { password }) =>
  apiClient.put(`/users/change-password/${id}`, { password });

// 🔍 Lookup user by identifiers (NIN, TIN, or Certificate Number)
export const lookupUserByIdentifier = ({ nin, tin, certificate_number }) => {
  const params = {};
  if (nin) params.nin = nin;
  if (tin) params.tin = tin;
  if (certificate_number) params.certificate_number = certificate_number;
  return apiClient.get('/users/lookup', { params });
};

// 🔹 Get all valuers or non-valuers (filter by is_valuer)
export const getAllValuers = (is_valuer = true) =>
  apiClient.get('/users/valuers', { params: { is_valuer } });

// 🔹 Request OTP for password reset
export const requestUserOtp = (data) =>
  apiClient.post('/users/reset-password/request', data);

// 🔹 Verify OTP code
export const verifyUserOtp = (data) =>
  apiClient.post('/users/reset-password/verify', data);

// 🔹 Confirm password reset after OTP verification
export const confirmUserResetPassword = (data) =>
  apiClient.post('/users/reset-password/confirm', data);


// Councils
export const getAllCouncils = (page = 0, size = 10) =>
  apiClient.get('/councils', { params: { page, size, sort: 'createdAt,desc' } });
export const getCouncil = (id) => apiClient.get(`/councils/${id}`);
export const createCouncil = (data) => apiClient.post('/councils', data);
export const uploadCouncils = (formData) =>
  apiClient.post('/councils/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateCouncil = (id, data) => apiClient.put(`/councils/${id}`, data);
export const deleteCouncil = (id) => apiClient.delete(`/councils/${id}`);

// Wards
export const getAllWards = (page = 0, size = 10) =>
  apiClient.get('/wards', { params: { page, size, sort: 'createdAt,desc' } });
export const getWard = (id) => apiClient.get(`/wards/${id}`);
export const createWard = (data) => apiClient.post('/wards', data);
export const uploadWards = (formData) =>
  apiClient.post('/wards/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateWard = (id, data) => apiClient.put(`/wards/${id}`, data);
export const deleteWard = (id) => apiClient.delete(`/wards/${id}`);

// Project categories
export const getAllProjectCategories = (page = 0, size = 10) =>
  apiClient.get('/project-categories', { params: { page, size, sort: 'createdAt,desc' } });
export const getProjectCategory = (id) => apiClient.get(`/project-categories/${id}`);
export const createProjectCategory = (data) => apiClient.post('/project-categories', data);
export const updateProjectCategory = (id, data) => apiClient.put(`/project-categories/${id}`, data);
export const deleteProjectCategory = (id) => apiClient.delete(`/project-categories/${id}`);

// Projects
export const getAllProjects = (page = 0, size = 10) =>
  apiClient.get('/projects', { params: { page, size, sort: 'createdAt,desc' } });
export const getProject = (id) => apiClient.get(`/projects/${id}`);
export const createProject = (data) => apiClient.post('/projects', data);
export const updateProject = (id, data) => apiClient.put(`/projects/${id}`, data);
export const deleteProject = (id) => apiClient.delete(`/projects/${id}`);

// Project-User Mapping
export const getAllMappedUsers = (page = 0, size = 10) =>
  apiClient.get('/project-users', { params: { page, size, sort: 'createdAt,desc' } });
export const getMappedUser = (id) => apiClient.get(`/project-users/${id}`);
export const createMappedUser = ({ userId, projectId, isCurrent = false }) =>
  apiClient.post(`/project-users/map?userId=${userId}&projectId=${projectId}&isCurrent=${isCurrent}`);
export const deleteMappedUser = (id) => apiClient.delete(`/project-users/${id}`);
export const getUserProjects = (userId) => apiClient.get(`/project-users/user/${userId}/projects`);

// Permissions
export const getAllPermissions = (page = 0, size = 10) =>
  apiClient.get('/permissions', {
    params: { page, size, sort: 'createdAt,desc' }
  });

export const getPermissionById = (id) =>
  apiClient.get(`/permissions/${id}`);

export const getPermissionsByController = (controller) =>
  apiClient.get(`/permissions/controller/${controller}`);

export const getPermissionsByCategory = (category) =>
  apiClient.get(`/permissions/category/${category}`);

export const createPermission = (data) =>
  apiClient.post('/permissions', data);

export const updatePermission = (id, data) =>
  apiClient.put(`/permissions/${id}`, data);

export const deletePermissionById = (id) =>
  apiClient.delete(`/permissions/${id}`);


// Mortgage Valuations
export const getAllMortgageValuations = (
  { projectId, clientId, status, startDate, endDate, page = 0, size = 10 } = {}
) =>
  apiClient.get('/mortgage-valuations', {
    params: {
      projectId,
      clientId,
      status,
      startDate,
      endDate,
      page,
      size,
      sort: 'createdAt,desc'
    }
  });

export const getMortgageValuation = (id) =>
  apiClient.get(`/mortgage-valuations/${id}`);

export const createMortgageValuation = (data) =>
  apiClient.post('/mortgage-valuations', data);

export const updateMortgageValuation = (id, data) =>
  apiClient.put(`/mortgage-valuations/${id}`, data);

export const patchMortgageValuation = (id, data) =>
  apiClient.patch(`/mortgage-valuations/${id}`, data);

export const deleteMortgageValuation = (id) =>
  apiClient.delete(`/mortgage-valuations/${id}`);

export const attachPropertyToMortgageValuation = (id, propertyData) =>
  apiClient.put(`/mortgage-valuations/attach-property/${id}`, propertyData);

// =====================
// Asset Valuations
// =====================

export const getAllAssetValuations = (
  { projectId, clientId, status, startDate, endDate, page = 0, size = 10 } = {}
) =>
  apiClient.get('/asset-valuations', {
    params: {
      projectId,
      clientId,
      status,
      startDate,
      endDate,
      page,
      size,
      sort: 'createdAt,desc'
    }
  });

export const getAssetValuation = (id) =>
  apiClient.get(`/asset-valuations/${id}`);

export const createAssetValuation = (data) =>
  apiClient.post('/asset-valuations', data);

export const updateAssetValuation = (id, data) =>
  apiClient.put(`/asset-valuations/${id}`, data);

export const patchAssetValuation = (id, data) =>
  apiClient.patch(`/asset-valuations/${id}`, data);

export const deleteAssetValuation = (id) =>
  apiClient.delete(`/asset-valuations/${id}`);

// 📦 Asset APIs
// Base: /api/v1/assets

// Get all assets (paginated)
export const getAllAssets = (page = 0, size = 10) =>
  apiClient.get('/assets', {
    params: { page, size, sort: 'createdAt,desc' },
  });

// Get a single asset by ID
export const getAsset = (id) => apiClient.get(`/assets/${id}`);

// Create a new asset
export const createAsset = (data) => apiClient.post('/assets', data);

// Update an existing asset
export const updateAsset = (id, data) => apiClient.put(`/assets/${id}`, data);

// Delete an asset
export const deleteAsset = (id) => apiClient.delete(`/assets/${id}`);

// 🔍 Search assets by name
export const searchAssets = (name) => {
  if (!name) throw new Error("Asset name is required for search");
  return apiClient.get(`/assets/search`, { params: { name } });
};


// ✅ Check if an asset exists by barcode
export const checkAssetByBarcode = (barcode) =>
  apiClient.get(`/assets/exists/barcode/${barcode}`);

// ✅ Get assets linked to a specific valuation
export const getAssetsByValuation = (assetValuationId) =>
  apiClient.get(`/assets/by-valuation/${assetValuationId}`);

// ✅ Get assets by category code (e.g., "ICT", "FURN", "BLDG") - all valuations (paginated)
export const getAssetsByCategoryCode = (categoryCode, page = 0, size = 10) =>
  apiClient.get(`/assets/by-category-code/${categoryCode}`, {
    params: { page, size }
  });



// Owners
export const getAllOwners = (page = 0, size = 10) =>
  apiClient.get('/owners', { params: { page, size, sort: 'createdAt,desc' } });

export const getOwner = (id) =>
  apiClient.get(`/owners/${id}`);

export const createOwner = (data) =>
  apiClient.post('/owners', data);

export const updateOwner = (id, data) =>
  apiClient.put(`/owners/${id}`, data);

export const deleteOwner = (id) =>
  apiClient.delete(`/owners/${id}`);

// check existence by phone number
export const ownerExistsByPhone = (phoneNumber) =>
  apiClient.get(`/owners/exists/phone/${phoneNumber}`);

// check existence by ID number
export const ownerExistsByIdNumber = (idNumber) =>
  apiClient.get(`/owners/exists/id-number/${idNumber}`);

// get owners linked to a specific mortgage valuation
export const getOwnersByValuation = (mortgageValuationId) =>
  apiClient.get(`/owners/by-valuation/${mortgageValuationId}`);



// Properties
export const getAllProperties = (page = 0, size = 10) =>
  apiClient.get('/properties', { params: { page, size, sort: 'createdAt,desc' } });

export const getProperty = (id) =>
  apiClient.get(`/properties/${id}`);

export const createProperty = (data) =>
  apiClient.post('/properties', data);

export const updateProperty = (id, data) =>
  apiClient.put(`/properties/${id}`, data);

export const deleteProperty = (id) =>
  apiClient.delete(`/properties/${id}`);

// Get properties by owner
export const getPropertiesByOwner = (ownerId) =>
  apiClient.get(`/properties/by-owner/${ownerId}`);

// Get properties by valuation
export const getPropertiesByValuation = (valuationId) =>
  apiClient.get(`/properties/by-valuation/${valuationId}`);

// Buildings
export const getAllBuildings = (page = 0, size = 10) =>
  apiClient.get('/buildings', { params: { page, size, sort: 'createdAt,desc' } });

export const getBuilding = (id) =>
  apiClient.get(`/buildings/${id}`);

export const createBuilding = (data) =>
  apiClient.post('/buildings', data);

export const updateBuilding = (id, data) =>
  apiClient.put(`/buildings/${id}`, data);

export const deleteBuilding = (id) =>
  apiClient.delete(`/buildings/${id}`);

// Get buildings by owner
export const getBuildingsByOwner = (ownerId) =>
  apiClient.get(`/buildings/by-owner/${ownerId}`);

// Get buildings by valuation
export const getBuildingsByValuation = (valuationId) =>
  apiClient.get(`/buildings/valuation/${valuationId}`);

// =====================
// Features
// =====================

// Get all features (paginated)
export const getAllFeatures = (page = 0, size = 10) =>
  apiClient.get('/features', { params: { page, size, sort: 'createdAt,desc' } });

// Get feature by ID
export const getFeature = (id) =>
  apiClient.get(`/features/${id}`);

// Create new feature
export const createFeature = (data) =>
  apiClient.post('/features', data);

// Update feature
export const updateFeature = (id, data) =>
  apiClient.put(`/features/${id}`, data);

// Delete feature
export const deleteFeature = (id) =>
  apiClient.delete(`/features/${id}`);

// Get features by valuation
export const getFeaturesByValuation = (valuationId) =>
  apiClient.get(`/features/valuation/${valuationId}`);


// =====================
// Attachments
// =====================

// Get all attachments (paginated)
export const getAllAttachments = (page = 0, size = 10) =>
  apiClient.get('/attachments', { params: { page, size, sort: 'createdAt,desc' } });

// Get attachment by ID
export const getAttachment = (id) =>
  apiClient.get(`/attachments/${id}`);

// Create new attachment
export const createAttachment = (data) =>
  apiClient.post('/attachments', data);

// Update attachment
export const updateAttachment = (id, data) =>
  apiClient.put(`/attachments/${id}`, data);

// Delete attachment
export const deleteAttachment = (id) =>
  apiClient.delete(`/attachments/${id}`);

// Get attachments by valuation
export const getAttachmentsByValuation = (valuationId) =>
  apiClient.get(`/attachments/valuation/${valuationId}`);


// =====================
// Crop Categories
// =====================

export const getAllCropCategories = (page = 0, size = 10) =>
  apiClient.get('/crop-categories', { params: { page, size, sort: 'createdAt,desc' } });

export const getCropCategory = (id) =>
  apiClient.get(`/crop-categories/${id}`);

export const createCropCategory = (data) =>
  apiClient.post('/crop-categories', data);

export const updateCropCategory = (id, data) =>
  apiClient.put(`/crop-categories/${id}`, data);

export const deleteCropCategory = (id) =>
  apiClient.delete(`/crop-categories/${id}`);


// =====================
// Role-Permissions
// =====================

// Get permissions assigned to a role
export const getRolePermissions = (roleId, page = 0, size = 10) =>
  apiClient.get(`/role-permissions`, {
    params: { roleId, page, size }
  });

// Assign multiple permissions to a role
export const assignPermissionsToRole = (roleId, permissions, page = 0, size = 10) =>
  apiClient.post(
    `/role-permissions/assign`,
    {
      role_id: roleId,          // must be plain string UUID
      permissions               // array of { permission_id, scope }
    },
    {
      params: { page, size }
    }
  );

// Remove a permission from a role
export const removePermissionFromRole = (roleId, permissionId, scope = null) =>
  apiClient.delete(`/role-permissions/${roleId}/${permissionId}`, {
    params: scope ? { scope } : {}
  });


// =====================
// Recent Valuations (Dashboard Widget)
// =====================

// Get the 5 most recent valuations – perfect for dashboard
export const getRecentValuations = () =>
  apiClient.get('/recent-valuations/dashboard');

// Get recent valuations with custom limit (optional – for admin pages)
export const getRecentValuationsWithLimit = (limit = 10) =>
  apiClient.get('/recent-valuations', {
    params: { limit }
  });


